module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "http://www.beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("豫ICP备15023008号")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-257bd700"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 72
// module chunks = 1